import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const WebinarSecurityApi = {
    getSettings: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['webinarSecurity', 'getSettings', webinarId], (api) => api.webinarSecurity.getSettings(webinarId), options),
    checkIsAllowed: (options?: BaseApiMutationOptions<ApiClient['webinarSecurity']['checkIsAllowed']>) =>
        apiMutationOptions((api) => api.webinarSecurity.checkIsAllowed, options),
    updateSettings: (options?: BaseApiMutationOptions<ApiClient['webinarSecurity']['updateSettings']>) =>
        apiMutationOptions((api) => api.webinarSecurity.updateSettings, options)
};
